import styled from "styled-components";
import colors from "../../../../config/colors";
import { isMobile } from "../../../../utils/common";

export const StockBrowserContainer = styled.div`
  background-color: ${colors.darkBackground};
  position: fixed;
  top: 0px;
  left: 50px;
  height: 100vh;
  width: calc(100vw - 50px);
  ${isMobile() &&
  `
        left:0px;
        width: 100vw;
        min-width:100vw;
        position: static;
        height:fit-content;
    `}
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  max-height: calc(100vh - ${isMobile() ? 200 : 100}px);
  min-height: calc(100vh - ${isMobile() ? 200 : 100}px);
  height: calc(100vh - ${isMobile() ? 200 : 100}px);
`;
